import { render, staticRenderFns } from "./ProjectDeliverableComponent.vue?vue&type=template&id=89c1b2ca&"
import script from "./ProjectDeliverableComponent.vue?vue&type=script&lang=js&"
export * from "./ProjectDeliverableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89c1b2ca')) {
      api.createRecord('89c1b2ca', component.options)
    } else {
      api.reload('89c1b2ca', component.options)
    }
    module.hot.accept("./ProjectDeliverableComponent.vue?vue&type=template&id=89c1b2ca&", function () {
      api.rerender('89c1b2ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/views/ProjectDeliverableComponent.vue"
export default component.exports